<template>
  <NavBar class="ImportNavBar">
    <router-link
      v-if="superuser"
      class="d-inline-flex align-center mr-3"
      :to="{ name: 'Dashboard', params: { municipality: activeMunicipalitySlug } }"
    >
      <i class="far fa-fw fa-gear icon" />
    </router-link>
  </NavBar>
</template>

<script>
import NavBar from '@/components/common/NavBar'

import { codeToSlug } from '@/services/municipalities'

import privilegesMixin from '@/mixins/common/privilegesMixin'

import { mapGetters } from 'vuex'

export default {
  name: 'ImportNavBar',
  components: {
    NavBar,
  },
  mixins: [privilegesMixin],
  computed: {
    ...mapGetters('config', [
      'hasLayers',
    ]),
    ...mapGetters('access', [
      'municipalityCodeList',
      'getActiveMunicipality',
      'hasAdminAccess',
    ]),
    activeMunicipalitySlug() {
      return codeToSlug({ code: this.getActiveMunicipality })
    },
    canPreAccessPrognose() {
      return this.hasLayers({ code: this.getActiveMunicipality }) && ( this.superuser || this.admin )
    },
  },
}
</script>

<style lang="scss">
.ImportNavBar {
  .icon {
    color: white;
    font-size: 1.75rem;
    cursor: pointer;
  }
}

.ExportNavBar__Logout {
  color: white;
  cursor: pointer;

  &:hover {
    color: var(--cta);
  }
}
</style>
